// Depends
import { group, subGroup, route, meta } from '@/helpers/routes'
import Me from './me/me'
import Schedule from './me/schedule'
import Overview from './me/overview'

const profileRoutes = [
  route('me', '/me', Me, meta('Meu Perfil', true, 'guest'))
]
const scheduleRoutes = [
  route('me', '/me', Schedule, meta('Meu Agendamentos', true, 'guest'))
]
const overviewRoutes = [
  route('me', '/me', Overview, meta('Visão Geral', true, 'guest'))
]
export default [
  ...group('/app/profile', [
    ...subGroup('/me', profileRoutes),
    ...subGroup('/schedules', scheduleRoutes),
    ...subGroup('/overview', overviewRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/profile/routes.js